import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { noop } from 'rxjs';
import { LsnErrorStateMatcher } from '../error-state-matcher';


export const CUSTOM_NUMPAD_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => NumPadComponent),
    multi: true
};

export class NumPadConfig {
    maxlength: number;
    allowLeadingZeros: boolean;
}

@Component({
    selector: 'app-numpad',
    templateUrl: './numpad.component.html',
    providers: [CUSTOM_NUMPAD_CONTROL_VALUE_ACCESSOR]
})
export class NumPadComponent implements OnInit, ControlValueAccessor {
    @Input() floatLabel: string;
    @Input() errorStateMatcher: LsnErrorStateMatcher;
    @Input() config: Partial<NumPadConfig> = {};
    @Input() placeholder: string;
    @Input() label: string;
    @Input() suffix: string;
    @Input() disabled = false;
    @Input() hintEnabled = false;
    @Input() hint: string;
    @Input() slim = false;
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onBlur = new EventEmitter();

    value: number = null;

    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;


    constructor() {
    }

    ngOnInit() {
    }

    onBlurAction() {
        this.onBlur.emit();
    }

    writeValue(value: any) {
        this.value = value;
        this.onChangeCallback(value);
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }
}
